import { graphql } from "gatsby"
import GatsbyImage from "gatsby-image"
import React from "react"
import DsaCppCodeFile from "../components/blogs/DsaCppCodeFile"
import Layout from "../components/layout"

function BlogPost({ data }) {
  const { blog, thumbnail } = data
  // console.log(blog, thumbnail)
  return (
    <Layout>
      <div className="container-fluid bg-dark blogPost pt-5">
        <div className="row mb-2">
          <div className="col-md-6 mx-1 p-0 mx-md-auto mt-5 text-center text-white">
            <GatsbyImage
              fluid={thumbnail.childImageSharp.fluid}
              className="my-3"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8 mx-1 mx-lg-auto my-lg-2 p-0 card">
            <div className="card-header text-center p-2">
              <h4 className="blog-title">{blog.frontmatter.title}</h4>
              {/* <h6>
                <i className="fas fa-clock mr-1"></i>
                <span>{blog.frontmatter.date}</span>
              </h6> */}
            </div>
            <div
              className="card-body p-1"
              dangerouslySetInnerHTML={{ __html: blog.excerpt }}
            ></div>
            {blog.frontmatter.dsaCppCodeFile && (
              <DsaCppCodeFile
                link={blog.frontmatter.dsaCppCodeFile}
                title={blog.frontmatter.title}
              />
            )}
            <div className="my-2 px-2">
              <p className="lead">
                That's it from this blog post. If you liked it then do share
                this blog with your friends or people who wanna get into
                programming world. Thank You!
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default BlogPost

export const postQuery = graphql`
  query Post($blog: String!, $thumbnail: String!) {
    blog: markdownRemark(frontmatter: { blog: { eq: $blog } }) {
      frontmatter {
        title
        thumbnail
        date
        dsaCppCodeFile
      }
      excerpt(format: MARKDOWN)
      html
    }
    thumbnail: file(relativePath: { eq: $thumbnail }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`
